<template>
  <div class="emailConfigDetail">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <van-field
        v-model="form.CustomerServiceEmail"
        :label="$t.marketRisk.serviceEmail"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.ContactPhone"
        :label="$t.marketRisk.contactPhone"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.WeChatId"
        :label="$t.marketRisk.wechat"
        :placeholder="isView ? '' : $t.meta.input"
        :disabled="isView ? true : false"
        required
        :rules="formRule"
      />

      <van-field :label="$t.marketRisk.fileQrcode">
        <template #input>
          <van-uploader
            v-model="fileColleagueQrCode"
            :max-count="1"
            :after-read="afterRead1"
            :deletable="isView ? false : true"
          />
        </template>
      </van-field>

      <van-field :label="$t.marketRisk.accountQrcode">
        <template #input>
          <van-uploader
            v-model="officialAccountsQrCode"
            :max-count="1"
            :after-read="afterRead2"
            :deletable="isView ? false : true"
          />
        </template>
      </van-field>

      <van-field :label="$t.marketRisk.isEnabled" readonly>
        <template #right-icon>
          <van-switch
            v-model="form.IsEnabled"
            :active-value="1"
            :inactive-value="0"
            size="24"
            :disabled="isView ? true : false"
          />
        </template>
      </van-field>

      <div style="margin: 16px" v-if="!isView">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.save
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import {
  Form,
  Field,
  Button,
  Icon,
  Image,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Popup,
  Uploader,
  Switch,
} from "vant";
Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Popup)
  .use(Uploader)
  .use(Switch);

export default {
  name: "emailConfigDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      isView: false,
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      fileColleagueQrCode: [],
      officialAccountsQrCode: [],
    };
  },
  created() {
    const { IsView } = this.$route.query;
    this.isView = IsView;
    if (IsView) {
      var data = JSON.parse(localStorage.getItem("emailConfigDetail"));
      this.form = data;
      this.firstLoad();
    } else {
      this.form = {
        CustomerServiceEmail: "",
        ContactPhone: "",
        WeChatId: "",
        FileColleagueQrCode: "",
        OfficialAccountsQrCode: "",
        IsEnabled: 0,
      };
    }
  },
  methods: {
    firstLoad() {
      if (this.form.FileColleagueQrCode) {
        this.fileColleagueQrCode.push({
          url: this.imgUrlFilter(this.form.FileColleagueQrCode),
        });
      }
      if (this.form.OfficialAccountsQrCode) {
        this.officialAccountsQrCode.push({
          url: this.imgUrlFilter(this.form.OfficialAccountsQrCode),
        });
      }
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CompanyId = this.CompanyId;
      this.$api.marketRisk
        .addEmailConfig(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.FileColleagueQrCode = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    afterRead2(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.OfficialAccountsQrCode = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.emailConfigDetail {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #323233 !important;
      -webkit-text-fill-color: #323233 !important;
    }
  }
}
</style>
